import React from "react";
import { FormContext } from "src/context/NewPremiseFormContext";
import { getFormBehavior } from "../helper";
import { RequestStatusEnum } from "src/components/Premises";
import { FormValues } from "../../types";
import { useFormikContext } from "formik";

export const useCloseTransferFormProps = () => {
  const { values, setFieldValue, setErrors, errors } =
    useFormikContext<FormValues>();
  const {
    formState: {
      closeTransfer: closeTransferPayload,
      electricityService,
      gasServices,
    },
    setDisplayingSnackbar,
    setFormState,
  } = React.useContext(FormContext);
  //don't support gasLine close and transfer
  const gasService = gasServices?.gasMeter || gasServices?.both;
  const {
    show: hasElectricitySection,
    enable: isElectricityEnable,
    readOnly: isElectricityReadOnly,
  } = getFormBehavior(
    electricityService?.requestStatus || RequestStatusEnum.NONE,
    electricityService?.connectionType
  );

  const {
    show: hasGasSection,
    enable: isGasEnable,
    readOnly: isGasReadOnly,
  } = getFormBehavior(
    gasService?.requestStatus || RequestStatusEnum.NONE,
    gasService?.connectionType
  );

  const isLegacy = React.useMemo(() => {
    return values.closeTransfer.fileMeta !== undefined;
  }, [values.closeTransfer]);

  const accountPayers = React.useMemo(
    () => [
      values.electricityAccountPayer,
      values.gasLine?.accountPayer,
      values.gasMeter?.accountPayer,
      values.both?.accountPayer,
    ],
    [
      values.electricityAccountPayer,
      values.gasLine?.accountPayer,
      values.gasMeter?.accountPayer,
      values.both?.accountPayer,
    ]
  );

  return {
    selectedFormState: {
      electricityService,
      gasServices,
      gasService,
      closeTransferPayload,
    },
    newPremiseFormContext: {
      setDisplayingSnackbar,
      setFormState,
    },
    formBehavior: {
      hasElectricitySection,
      isElectricityEnable,
      isElectricityReadOnly,
      hasGasSection,
      isGasEnable,
      isGasReadOnly,
      accountPayers,
    },
    formikContext: {
      values,
      setFieldValue,
      setErrors,
      errors,
    },
    isLegacy,
  };
};
